export default __webpack_public_path__ + "static/media/x2y2.b072784c.png";